// 会场管理 getters
export default {
  /** 是否已登录 */
  isVenueLogin: state => state.isLogin,
  /** 获取登录信息 */
  venueLoginInfo: state => state.loginInfo,
  /** 获取 token */
  venueToken: state => state.token
}
